// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"1ff759c1","117":"b9968054","188":"6e5c2d41","230":"91743a69","243":"e86d9fd2","808":"f1e3aedf"}[chunkId] + ".chunk.css";
};